import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';

import App from '../screens/app';
import Front from '../screens/front';
import Article from '../screens/article';
import PlussFront from '../screens/front/pluss';
import Collection from '../screens/front/collection';
import Contact from '../screens/contact';
import Responsible from '../screens/responsible';
import GenericError from '../screens/error';
import EmbedComponent from '../screens/embed';
import Comments from '../screens/embed/fb-comments';
import AuthCallback from '../screens/auth-callback';

export default () => (
    <Router>
        <Route component={EmbedComponent}>
            <Route path="/embed/fb-comments" component={Comments} />
        </Route>
        <Route component={App}>
            <IndexRoute component={Front} />
            <Route path="/(:section/)(:subSection/)i/:id(/:title)" component={Article} />
            <Route path="/(:section/)(:subSection/)(:title/)i/:id" component={Article} />
            <Route path="/pluss" component={PlussFront} />
            <Route path="/om-vg/ansvarlige-personer" component={Responsible} />
            <Route path="/om-vg/kontakt-oss" component={Contact} />
            <Route path="/tag/:tag(/:title)" component={Collection} />
            <Route path="/emne/:story(/:title)" component={Collection} />
            <Route path="/auth/callback" component={AuthCallback} />
            <Route path="/:section(/:subSection)(/:tagTitle)" component={Collection} />
            <Route path="*" component={GenericError} />
        </Route>
    </Router>
);



/** WEBPACK FOOTER **
 ** ./src/routes/index.js
 **/